const booking = {
  root: "Réservation",
  root_plural: "Réservations",
};
export default booking;
